<footer
  *ngIf="!showFooter" 
  [ngClass]="{'fixed-box-height': addFixedBoxheight,
                    'footer-christmas-wt': _globalsService.itsCristhmasHolidays() && sys === 'wt',
                    'footer-christmas-ltk': _globalsService.itsCristhmasHolidays() && sys === 'ltk'}"
  class="footer-{{sys}}"
>
  <div class="content-wrap txt-center">
    <h3 class="terms">
      <p class="white">
        <a (click)="openTerminsAndPolicy(2)" href="javascript:void(0);" class="white" title="Terms and Conditions"> {{'T&C' | translate}} </a>
      </p>
    </h3>
    <app-copy></app-copy>
  </div>
</footer>
